<div *ngIf="footerSettings && footerSettings.length" class="footer-container" role="contentinfo">
  <div class="container">
    <div class="top-container">
      <div class="row">
        <div class="logos-container col-6">
          <div class="assurant-logo">
            <adp-image imageKey="Global_Footer_Logo"></adp-image>
          </div>
          <div class="footer-logos-left d-flex flex-row d-md-none">
            <adp-image imageKey="Global_SSL"></adp-image>
            <adp-image imageKey="Global_PCI"></adp-image>
          </div>
        </div>
        <div class="links-container col-6">
          <div class="d-flex flex-column align-items-end">
            <div class="link-wrap">
              <!-- TODO: uncomment and add href when refer features is complete -->
              <!-- <span class="footer-link d-block">
                    <a href="#">Refer A Friend<mat-icon svgIcon="share"></mat-icon></a>
                </span> -->
              <ng-container *ngFor="let item of footerSettings">
                <span class="footer-link d-block d-md-none">
                  <a
                    href="{{ item.LinkUrl }}"
                    target="{{ item.OpenNewTab ? '_blank' : '_self' }}"
                    [gtmClick]="item.Caption"
                    [gtmLinkURL]="item.LinkUrl"
                    >{{ item.Caption }}</a
                  >
                </span>
              </ng-container>

              <div class="footer-logos d-none d-md-block">
                <adp-image imageKey="Global_SSL"></adp-image>
                <adp-image imageKey="Global_PCI"></adp-image>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-notice">
      <span (click)="toggleAdminSection()">© {{ this.year }} <adp-label labelKey="Global_Footer_Copyright"></adp-label></span>
      <div class="footer-notice-links-container d-none d-md-block">
        <ng-container *ngFor="let item of footerSettings">
          <span class="footer-link">
            <a
              href="{{ item.LinkUrl }}"
              target="{{ item.OpenNewTab ? '_blank' : '_self' }}"
              [gtmClick]="item.Caption"
              [gtmLinkURL]="item.LinkUrl"
              >{{ item.Caption }}</a
            >
          </span>
        </ng-container>
      </div>
    </div>

    <div class="footer-mobile">
      <mat-divider class="footer-divider"></mat-divider>
      <ng-container *ngFor="let item of footerSettings">
        <div class="footer-link">
          <a
            href="{{ item.LinkUrl }}"
            target="{{ item.OpenNewTab ? '_blank' : '_self' }}"
            [gtmClick]="item.Caption"
            [gtmLinkURL]="item.LinkUrl"
            >{{ item.Caption }}</a
          >
        </div>
      </ng-container>
      <div (click)="toggleAdminSection()" class="footer-remark">
        © {{ this.year }} <adp-label labelKey="Global_Footer_Copyright"></adp-label>
      </div>
    </div>
    <adp-setting key="Global_AllowContentAuthoring"></adp-setting>

    <div *ngIf="isAdminSectionVisible" ifSettingTrue="Global_AllowContentAuthoring">
      <button (click)="reloadSite()" class="btn btn-primary btn-outline-light" id="resetSiteMobile" style="height: 35px">Refresh</button>
      <button
        ifSettingTrue="Global_AllowContentAuthoring"
        (click)="toggleDeveloperMode()"
        class="btn btn-primary btn-outline-light ms-3"
        style="height: 35px">
        <span *ngIf="resourceService.isEditMode">Dev Off </span>
        <span *ngIf="!resourceService.isEditMode">Dev On </span>
      </button>

      <button
        ifSettingTrue="Global_CMS_Enabled"
        class="btn btn-primary btn-outline-light ms-3"
        (click)="showEditorPage()"
        style="height: 35px">
        Editor Page
      </button>

      <button
        ifSettingTrue="Global_CMS_Enabled"
        class="btn btn-primary btn-outline-light ms-3"
        (click)="showCMSPage()"
        style="height: 35px">
        CMS Page
      </button>

      <form [formGroup]="footerForm" class="dd-footer ms-3">
        <mat-form-field class="no-line">
          <mat-select
            class="footer-tools"
            title="Select Elita Environment"
            [(value)]="selectedElitaEnvironment"
            [disabled]="isAuthenticated"
            formControlName="ElitaEnvironment"
            (selectionChange)="setElitaEnvironment()">
            <mat-option *ngFor="let ee of elitaEnvironments" [value]="ee.Key">
              <div class="d-inline-block">{{ ee.Value }}</div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </div>
</div>
